import React from "react";

import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { useAuthorityType } from "@libs/roles/hooks/useAuthorityType";
import UrlPageEntryGuide from "@organisms/UrlPageEntryGuide/UrlPageEntryGuide";

import { useHasFillInTableLock } from "../hooks/useHasFillInTableLock";
import { FillInTableConcurrentAccessChecker } from "../services/fillInTableConcurrentAccessChecker";

interface Props {
  children: React.ReactNode;
}

const FillInTableConcurrentAccessGuard = ({ children }: Props) => {
  const { data: articleInfo } = useArticleInfoQuery();
  if (articleInfo === undefined) throw new Error("articleInfo is undefined");
  const { ftEditorName } = articleInfo;
  const currentUrl = window.location.href;
  const authorityType = useAuthorityType();

  const hasLock = useHasFillInTableLock({
    url: currentUrl,
    ftEditorName,
  });

  const fillInTableConcurrentAccessChecker =
    new FillInTableConcurrentAccessChecker({
      hasLock,
      ftEditorName,
      authorityType,
    });

  if (fillInTableConcurrentAccessChecker.canAccess) return <>{children}</>;
  else return <UrlPageEntryGuide />;
};

export default FillInTableConcurrentAccessGuard;
